export const iconFontAwesomeChildhoodBaby = (
	<i className="fa-solid fa-baby"></i>
);
